import * as Html from "../../util/Html.ts";
import { OS } from "../../lib/os.js";
import * as FwDatas from "../../FwDatas.ts";
import { getTimezonesSelect, rememberUsedTimezone } from "../../lib/TimezoneUtils.ts";
import {init as placePickerInit} from "./place-picker.js"
Html.registerWidget('widget/form/eventedit',{init:init})

//this stupid firefox doesn't understand change of type without removing the node and reputting it.'
function refresher(hop){
  hop = hop.get(0);
  var parent = hop.parentNode;
  parent.removeChild(hop);
  parent.appendChild(hop);
}

function init(o){
  var 
    form = o.get(0),
    isUpdate = o.metaId(),
    isOtherScope = form.scope && form.scope.value!=FwDatas.getFamily().metaId;
  
  if(isOtherScope){
    o.attr("data-fw-dyn-action","custom.evtcreateotherscope");
  }else if(isUpdate){
    o.attr("data-fw-dyn-action","custom.evtupdate");
    o.attr("data-fw-form-amplify","eventUpdated");
  }else{
    o.attr("data-fw-dyn-action","custom.evtcreate");
    o.attr("data-fw-form-amplify","eventCreated");
  }
  
  
  o.find(":input[name='private']").on('change',function(){
    if($(this).val()==='true'){
      o.find("[data-accountid='"+FwDatas.getUser().accountId+"']").trigger('click')
    }
  })
  
  var  
    startDateInput = o.find('[name="startDate"]'),
    endDateInput = o.find('[name="endDate"]'),
    allDayInput = o.find('[name="allDay"]'),
    morebutton =  o.find('.morebutton'),
    isMore = false,
    timeZoneSelect = o.get(0).querySelector('[name="timeZone"]'),
    timeZoneLabel = $(timeZoneSelect.parentNode),
    timezone = timeZoneSelect.getAttribute("data-value"),
    //those fields are just to check changes, value to take in account are the ones of the input
    start = startDateInput.dateValue(),
    end = endDateInput.dateValue(),
    allDay = allDayInput.prop('checked'),
    defaultTimeZone = OS.getTimeZone();

  //delegated because it might be long for slow computer  
  setTimeout(function(){
    timeZoneSelect.innerHTML = getTimezonesSelect()
    //timeZoneSelect.innerHTML = ["Europe/Paris","America/Chicago"].map(tz=>`<option value="${tz}">${tz}</option>`).join('')
    var 
      option = timeZoneSelect.querySelector(`[value="${timezone||defaultTimeZone}"]`);
    if(option){
      option.setAttribute('selected','selected');
    }
  },0)  
  function setDate(start,end){
    startDateInput.dateValue(null);
    endDateInput.dateValue(null);
    if(allDay){
      timeZoneSelect.setAttribute('disabled','disabled')
      timeZoneLabel.hide()
      startDateInput.attr('type','date').attr('timezone',timezone).dateValue(start)
      endDateInput.attr('type','date').attr('timezone',timezone).dateValue(end)
    }else{
      timeZoneSelect.removeAttribute("disabled");
      if(isMore || (timezone && timezone!==defaultTimeZone)){
        timeZoneLabel.show()
      }else{
        timeZoneLabel.hide()
      }
      startDateInput.attr('type','datetime-local').attr('timezone',timezone).dateValue(start)
      endDateInput.attr('type','datetime-local').attr('timezone',timezone).dateValue(end)
    }
    refresher(startDateInput)
    refresher(endDateInput)
  }
  setDate(start,end)
  function alldayMaj(){
    if(allDay===allDayInput.prop('checked')) return;
    allDay=allDayInput.prop('checked');
    setDate(start,end)
  }
  allDayInput.on('change',alldayMaj);
  
  startDateInput.on('blur',function(event){
    var 
      newDate = startDateInput.dateValue();
    if(!newDate) {
       startDateInput.dateValue(start)
       return;
    }  
    if(allDay){
      start.setFullYear(newDate.getFullYear())
      start.setDate(newDate.getDate())
      start.setMonth(newDate.getMonth())
    }else{
      start = newDate;
    }
    if(start>end){
      end = new Date(start.getTime()+3600000)
      endDateInput.dateValue(end)
    }
  })
  //WARNING it is onblur and not onchange because when you type "12" onchange is triggered first with "1" and after with "12" so with "1" it put the start at 0
  endDateInput.on('blur',function(event){
    
    var 
      newDate = endDateInput.dateValue();
    if(!newDate) {
       endDateInput.dateValue(end)
       return;
    }  
    
    if(allDay){
      end.setFullYear(newDate.getFullYear())
      end.setDate(newDate.getDate())
      end.setMonth(newDate.getMonth())
    }else{
      end = newDate;
    }
    if(start>end){
      start = new Date(end.getTime()-3600000)
      startDateInput.dateValue(start)
    }
  })
  timeZoneSelect.addEventListener('change',function(){
    timezone = $(this).val()
    startDateInput.attr("timezone",timezone)
    endDateInput.attr("timezone",timezone)
    rememberUsedTimezone(timezone)
  })
  morebutton.on('click',function(){
    $(this).prev().show(); 
    $(this).remove();
    placePickerInit($("[name=where]"))
    isMore = true;
    setDate(start,end)
  })
  
}